import * as React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { Select, TextInput } from 'components';
import { Checkbox } from 'components/atoms/Checkbox';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import { TOrderFormValues } from '../../OrderForm.types';

export const OrderFormPaymentSection: React.FC = () => {
  const localize = useLocalize();
  const { control } = useFormContext<TOrderFormValues>();
  const isManualPayment = useWatch({
    control,
    name: 'isManualPayment',
  });

  return (
    <section className="admin-orders-detail__section">
      <h3 className="h6 admin-orders-detail__section-title">
        {localize('admin.orders.form.section.payment')}
      </h3>
      <div className="admin-form__field-row admin-form__field-row--half">
        <div className="admin-form__field">
          <Controller
            name="isManualPayment"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                onChange={field.onChange}
                label="Is manual payment"
              />
            )}
          />
        </div>
        <div className="admin-form__field">
          <Controller
            name="payed"
            control={control}
            render={({ field }) => (
              <Checkbox
                checked={field.value}
                onChange={field.onChange}
                label={localize('admin.orders.detail.label.payed')}
              />
            )}
          />
        </div>
      </div>
      {isManualPayment ? (
        <div className="admin-form__field-row admin-form__field-row--half">
          <div className="admin-form__field">
            <Controller
              name="manualPaymentDate"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  type="datetime-local"
                  label="Payment date"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </div>
          <div className="admin-form__field">
            <Controller
              name="manualPaymentMethod"
              control={control}
              render={({ field, fieldState }) => (
                <Select
                  label="Method"
                  value={field.value}
                  onChange={field.onChange}
                  options={[
                    { id: 'cash', label: 'cash' },
                    { id: 'bankTransfer', label: 'bank transfer' },
                  ]}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>
        </div>
      ) : (
        <div className="admin-form__field">
          <Controller
            name="paymentJson"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                multiline
                minRows={6}
                label={
                  localize('admin.orders.form.label.payment.json') as string
                }
                onChange={field.onChange}
                value={field.value ?? ''}
                error={!!fieldState.error}
                helperText={
                  (fieldState.error?.message ??
                    localize('admin.orders.form.hint.payment.json')) as string
                }
                required
              />
            )}
          />
        </div>
      )}
    </section>
  );
};
